<form [formGroup]="formGroup" (ngSubmit)="submit()">
  <ng-content/>
</form>
